import { FC } from 'react';
import SubMenuRightContent from '../../common/components/menu/SubMenuRightContent';
import TopMenu from '../../common/components/menu/TopMenu';
import * as Paths from '../../common/constants/paths';
import { Icon } from '@hologram-dimension/icon';
import { Plan } from 'common-js/types/Plan';

const PlanMenu: FC<{ plan?: Plan }> = ({ plan }) => {
  return (
    <TopMenu rightContent={<SubMenuRightContent />}>
      <TopMenu.Item
        text={'Data plans'}
        href={Paths.withContext(Paths.BILLING_DATA_PLANS)}
        className="grid-row v-align grid-gap-halfx"
      >
        <Icon
          name="ChevronSingleWest"
          size="small"
          fill="DdsColorPaletteWhite"
          style={{ transform: 'translateY(-0.5px)' }}
        />
      </TopMenu.Item>
      <TopMenu.Item active isDeviceName text={plan?.planName ?? 'Not found'} />
    </TopMenu>
  );
};
export default PlanMenu;
